/**
 * Custom SectionFooter for ConstructionYardSale.com
 * Receives same props as default SectionFooter (Console data),
 * renders with industrial Tailwind design from Replit.
 */
import React from 'react';
import { LinkedLogo, NamedLink } from '../../../../components';

import Field from '../../Field';
import BlockBuilder from '../../BlockBuilder';

const MAX_MOBILE_SCREEN_WIDTH = 1024;

const SectionFooterCustom = props => {
  const {
    sectionId,
    numberOfColumns = 1,
    socialMediaLinks = [],
    slogan,
    copyright,
    blocks = [],
    options,
    linkLogoToExternalSite,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const linksWithBlockId = socialMediaLinks?.map(sml => ({
    ...sml,
    blockId: sml.link.platform,
  }));

  const showSocialMediaLinks = socialMediaLinks?.length > 0;
  const hasMatchMedia = typeof window !== 'undefined' && window?.matchMedia;
  const isMobileLayout = hasMatchMedia
    ? window.matchMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH}px)`)?.matches
    : true;
  const logoLayout = isMobileLayout ? 'mobile' : 'desktop';

  return (
    <footer id={sectionId} className="bg-secondary text-secondary-foreground py-12 mt-auto">
      <div className="container mx-auto px-4">
        {/* Top row: Logo + Brand + Links */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo + Brand */}
          <div className="flex items-center gap-3">
            <LinkedLogo
              rootClassName="flex items-center"
              logoClassName="h-12 w-auto"
              logoImageClassName="h-12 w-auto"
              linkToExternalSite={linkLogoToExternalSite}
              layout={logoLayout}
            />
          </div>

          {/* Navigation links from Console blocks */}
          {blocks?.length > 0 && (
            <div className="flex flex-wrap gap-6 text-sm font-heading font-medium tracking-wide">
              <BlockBuilder blocks={blocks} sectionId={sectionId} options={options} />
            </div>
          )}
        </div>

        {/* Social media icons */}
        {showSocialMediaLinks && (
          <div className="flex justify-center gap-4 mt-6">
            <BlockBuilder blocks={linksWithBlockId} sectionId={sectionId} options={options} />
          </div>
        )}

        {/* Slogan */}
        {slogan && (
          <div className="mt-6 text-center">
            <Field data={slogan} className="text-sm text-secondary-foreground/80" />
          </div>
        )}

        {/* Copyright */}
        <div className="mt-8 text-center text-sm text-secondary-foreground/60">
          {copyright ? (
            <Field data={copyright} />
          ) : (
            <span>&copy; {new Date().getFullYear()} ConstructionYardSale.com. All rights reserved.</span>
          )}
        </div>
      </div>
    </footer>
  );
};

export default SectionFooterCustom;
